import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  Input,
} from '@angular/core';
import { LayoutService } from '../services/layout.service';
import {LegalDocumentsService} from '../services/legal-documents.service';

@Component({
  selector: 'app-header-dashboard',
  templateUrl: './header-dashboard.component.html',
  styleUrls: [],
})
export class HeaderDashboardComponent implements OnInit {
  @Input() userIsLogged: boolean;
  @Input() avatarShortName: string;
  @Input() username: string;
  @Input() userEmail: string;

  @Output() sideMenuEventEmitter = new EventEmitter();

  @Output() signOutEventEmitter = new EventEmitter();

  menuNotificationsStatus = false;
  menuUserStatus = false;

  constructor(
    private layoutService: LayoutService,
    private legalDocumentsService: LegalDocumentsService,
  ) {}

  ngOnInit(): void {}

  signOutEventEmit() {
    this.menuUserStatus = false;
    this.signOutEventEmitter.emit();
  }

  setLogoRouterLink() {
    if (this.userIsLogged === true) {
      return '/menu/home';
    } else {
      return '/home';
    }
  }

  toggleSideMenuEventEmit() {
    this.sideMenuEventEmitter.emit();
    setTimeout(() => {
      this.layoutService.hasResized(null);
    }, 500);
  }

  hideAll() {
    this.menuNotificationsStatus = false;
    this.menuUserStatus = false;
  }

  showMenuNotifications() {
    if (!this.menuNotificationsStatus) {
      this.hideAll();
    }
    this.menuNotificationsStatus = !this.menuNotificationsStatus;
  }
  showMenuUser() {
    if (!this.menuUserStatus) {
      this.hideAll();
    }
    this.menuUserStatus = !this.menuUserStatus;
  }

  download(type: number) {
    this.legalDocumentsService.downloadActiveLegalDocument(type);
  }
}
